module.exports = __webpack_public_path__ + "media/images/help/apple-touch-icon-180x180-5cbe18a219c79850128d749dac439b54.png";